import { useContext } from 'react';
import { MenuCollapseContext } from '../providers/MenuCollapseProvider';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => useContext(MenuCollapseContext);
